<template>
  <div class="celebrate-container">
    <confetti
      ref="confetti"
      v-bind="confettiConfig"
      @celebration-complete="onCelebrationComplete"
      @celebration-stopped="onCelebrationStopped"
    />
  </div>
</template>

<script>
import Confetti from "./Components/Confetti.vue";

export default {
  name: "Celebrate",
  components: {
    Confetti
  },
  props: {
    // Celebration type - can be extended for different celebration styles
    type: {
      type: String,
      default: "confetti",
      validator: value => ["confetti"].includes(value)
    },
    // Pass-through props for confetti configuration
    spread: {
      type: Number,
      default: 270
    },
    angle: {
      type: Number,
      default: 90
    },
    ticks: {
      type: Number,
      default: 400
    },
    gravity: {
      type: Number,
      default: 0.4
    },
    decay: {
      type: Number,
      default: 0.9
    },
    startVelocity: {
      type: Number,
      default: 33
    },
    colors: {
      type: Array,
      default: () => ["FFE400", "FFBD00", "E89400", "FFCA6C", "FDFFB8"]
    },
    originY: {
      type: Number,
      default: 0.4
    },
    originX: {
      type: Number,
      default: 0.5
    },
    zIndex: {
      type: Number,
      default: 10000
    },
    particleCount1: {
      type: Number,
      default: 200
    },
    scalar1: {
      type: Number,
      default: 1.8
    },
    shapes1: {
      type: Array,
      default: () => ["square"]
    },
    particleCount2: {
      type: Number,
      default: 100
    },
    scalar2: {
      type: Number,
      default: 0.95
    },
    shapes2: {
      type: Array,
      default: () => ["circle"]
    },
    delays: {
      type: Array,
      default: () => [0]
    },
    // Auto-trigger celebration on mount
    autoTrigger: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    confettiConfig() {
      return {
        spread: this.spread,
        angle: this.angle,
        ticks: this.ticks,
        gravity: this.gravity,
        decay: this.decay,
        startVelocity: this.startVelocity,
        colors: this.colors,
        originY: this.originY,
        originX: this.originX,
        zIndex: this.zIndex,
        particleCount1: this.particleCount1,
        scalar1: this.scalar1,
        shapes1: this.shapes1,
        particleCount2: this.particleCount2,
        scalar2: this.scalar2,
        shapes2: this.shapes2,
        delays: this.delays
      };
    }
  },
  mounted() {
    if (this.autoTrigger) {
      this.celebrate();
    }
  },
  methods: {
    /**
     * Trigger celebration
     */
    celebrate() {
      if (this.type === "confetti") {
        this.$refs.confetti.celebrate();
      }
      this.$emit("celebration-started");
    },

    /**
     * Stop celebration
     */
    stop() {
      if (this.type === "confetti") {
        this.$refs.confetti.stop();
      }
      this.$emit("celebration-stopped");
    },

    /**
     * Handle celebration completion
     */
    onCelebrationComplete() {
      this.$emit("celebration-complete");
    },

    /**
     * Handle celebration stopped
     */
    onCelebrationStopped() {
      this.$emit("celebration-stopped");
    }
  }
};
</script>

<style scoped>
.celebrate-container {
  /* Container for celebration effects */
  position: relative;
}
</style>
